import type { FieldsetField, FieldsetFieldWithDetails } from '@/types';

/**
 * splitConsentLabel is a function that takes consent label and split it into two parts: label and details
 * based on whether it contains expandable tags (if not it returns empty string in detailsText)
 *
 * @param {string} label - The label to be split.
 * @returns {{ labelText: string, detailsText: string }} - An object with labelText and detailsText.
 */
export const splitConsentLabel = (label: string) => {
    const startTag = '<expandable>';
    const endTag = '</expandable>';
    const startIndex = label.indexOf(startTag);
    const endIndex = label.indexOf(endTag);
    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
        const labelText = label.substring(0, startIndex);
        const detailsText = ' ' + label.substring(startIndex + startTag.length, endIndex);
        return { labelText, detailsText };
    }
    return { labelText: label, detailsText: '' };
};

/**
 * Adds details to each field in a fieldset by splitting the label into label text and details text.
 *
 * @param fields - An array of fieldset fields to be processed.
 * @returns An array of fieldset fields with added details.
 */
export const addDetailsToFieldsetField = (fields: FieldsetField[]): FieldsetFieldWithDetails[] => {
    return fields.map(field => {
        const { labelText, detailsText } = splitConsentLabel(field.options.label);
        return {
            ...field,
            options: {
                ...field.options,
                label: labelText,
                details: detailsText
            }
        };
    });
};
